import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.check();
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.check();
  }

  // SECURITY: `isLoggedIn` richiede LoggedInUser + apiToken presente e non
  // scaduto (fail-closed). Se manca, ha già fatto il logout pulito
  // (`resetUser`): qui resta solo il redirect al login admin.
  private check(): boolean {
    if (this.auth.isLoggedIn()) {
      return true;
    }
    this.router.navigateByUrl('/admin/login');
    return false;
  }
}
